export enum SystemErrorCode {
  Unexpected = 9099
}

export enum ApplicationSetting {
  Interval = 205,
  MaintenanceActiveInterval = 206,
  MaintenanceReminderStart = 213,
  MaintenanceReminderInterval = 214,
  MaintenanceReminderMessage = 215,
  MaintenanceActiveFrom = 217,
  MaintenanceActiveTo = 218,
  MaintenanceActiveMessage = 219,
}
